import type { Auth0ContextInterface, User } from "@auth0/auth0-react";
import { createRouter, Navigate } from "@tanstack/react-router";
import type { CodeRouteToPath } from "@tanstack/router-core";
import type { QueryClient } from "@tanstack/react-query";

import ErrorBoundary from "@subly/s1/ui/composed/ErrorBoundary";
import { getContext } from "@subly/s1/ui/composed/QueryProvider";

import validation from "core/validation";

import { routeTree } from "./routeTree.gen";


declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router
	}
}

export type RouterContext = {
	queryClient: QueryClient;
	auth0?: Auth0ContextInterface<User>
};

export type ValidRoutes = CodeRouteToPath<typeof router>;

const router = createRouter({
	routeTree,
	context: {
		...getContext({ auth0: undefined })
	},
	defaultPreload: "intent",
	scrollRestoration: false,
	defaultStructuralSharing: true,
	defaultPreloadStaleTime: 0,
	defaultErrorComponent: (error) => <ErrorBoundary error={error} />,
	defaultOnCatch: (e) => {
		const error = validation.serializeError(e);
		/* if (!error.type) api.error.log({ name: error.name, message: error.message, stack: stack.componentStack }); */
		return error;
	},
	defaultNotFoundComponent: () => <Navigate to="/" />
});

export default router;